module.exports = __webpack_public_path__ + "img/76334.46f1e75a.svg";